import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * /documents/review — now redirects to the unified AI proposal review
 * screen at /proposals.
 *
 * There used to be two review surfaces: this route (the older three-column
 * `DocumentsReviewPane`) and `/proposals`. The `/proposals` screen was
 * rebuilt for clarity (readable headlines, grouped queue, in-place decision
 * notes) and is now the single canonical review UI. This route stays as a
 * stable redirect so existing links / bookmarks (the Documents AI-queue
 * banner, the contract baseline "Open review queue" CTA) keep working.
 */
export const Route = createFileRoute('/engagements/$engagementId/documents/review')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/engagements/$engagementId/proposals',
      params: { engagementId: params.engagementId },
    });
  },
});
